// src/components/SearchAndCategorySection/SearchAndCategorySection.js
import React from "react";
import SearchBar from "./SearchBar";
import CategoryGrid from "../category/CategoryGrid"; // import again
import "./SearchAndCategorySection.css";

const SearchAndCategorySection = ({
  searchText,
  provinceId,
  onSearchTextChange,
  onProvinceChange,
}) => {
  return (
    <div className="search-category-container">
      <SearchBar
        searchText={searchText}
        provinceId={provinceId}
        onSearchTextChange={onSearchTextChange}
        onProvinceChange={onProvinceChange}
      />
      <CategoryGrid />
    </div>
  );
};

export default SearchAndCategorySection;
